import { YandexMetrika } from './YandexMetrika';

export const ym = new YandexMetrika(25018181);
